/**
 * Calcoli del divisore fra due pannelli.
 *
 * Separati dal componente perché sono la parte che può sbagliare in modi
 * difficili da notare guardando lo schermo: un pannello ridotto a zero larghezza
 * non si recupera più col mouse, e un valore non numerico salvato nel browser
 * romperebbe il layout al caricamento successivo.
 */

export const LIMITI = {
  /** Sotto questa soglia un pannello diventa inutilizzabile. */
  minimo: 25,
  massimo: 80,
  predefinito: 62,
} as const;

/**
 * Riporta una percentuale entro i limiti utilizzabili.
 *
 * Un valore fuori scala e un valore non calcolabile sono situazioni diverse:
 * trascinando oltre il bordo sinistro la percentuale diventa negativa, e in quel
 * caso il divisore deve fermarsi al minimo. Trattarla come "non valida" lo
 * farebbe saltare al valore predefinito, con uno scatto ben visibile.
 */
export function restringi(percentuale: number): number {
  if (!Number.isFinite(percentuale)) return LIMITI.predefinito;

  // Un decimale basta: il pixel in più non si vede, e la stringa resta pulita.
  const arrotondata = Math.round(percentuale * 10) / 10;

  return Math.min(LIMITI.massimo, Math.max(LIMITI.minimo, arrotondata));
}

export interface Contenitore {
  /** Distanza del bordo sinistro dal bordo della finestra. */
  readonly sinistra: number;
  readonly larghezza: number;
}

/**
 * Percentuale corrispondente alla posizione del puntatore.
 *
 * Il valore risultante è già entro i limiti: trascinare fuori dal contenitore
 * ferma il divisore invece di far sparire un pannello.
 */
export function percentualeDaTrascinamento(
  puntatoreX: number,
  contenitore: Contenitore,
): number {
  if (contenitore.larghezza <= 0) return LIMITI.predefinito;

  return restringi(((puntatoreX - contenitore.sinistra) / contenitore.larghezza) * 100);
}
